import { City, State } from "country-state-city";


const INDIAN_STATES = State.getStatesOfCountry("IN");

export const indianStateNames = () => INDIAN_STATES.map((state) => state.name);

export const districtOptionsForState = (stateName) => {
  const state = INDIAN_STATES.find((s) => s.name === stateName);
  if (!state) return [];
  const names = City.getCitiesOfState("IN", state.isoCode).map((city) => city.name);
  return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
};
